import {fetchNotifications} from '../store/slices/notifications_slice';
import {store as AppStore} from '../store/store';

export async function notificationsLoader(store: typeof AppStore) {
    const token = store.getState().exchangeToken.token;
    if (token) {
        const result = await store.dispatch(fetchNotifications({token}));

        return result;
    }
    return null;
}
